<template>
  <v-tooltip
    left
    :disabled="!tooltip"
  >
    <template v-slot:activator="{on, attrs}">
      <v-btn
        small
        icon
        dark
        class="mr-1"
        v-bind="attrs"
        v-on="on"
        @click="keepWindowOpenedClick"
      >
        <v-icon
          v-if="value"
          size="large"
          color="orange"
        >
          mdi-pin
        </v-icon>
        <v-icon
          v-else
          size="large"
        >
          mdi-pin-outline
        </v-icon>
      </v-btn>
    </template>
    <span>{{ tooltip }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, default: false },
    storeKey: { type: String, default: "" },
    tooltip: { type: String, default: "" }
  },

  created() {
    const storeValue = localStorage.getItem(this.storeKey) === "true"
    if (this.value != storeValue) this.$emit("input", storeValue)
  },

  methods: {
    keepWindowOpenedClick() {
      const newValue = !this.value
      localStorage.setItem(this.storeKey, newValue)
      this.$emit("input", newValue)
    }
  }
}
</script>
